//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { RightsRequestCommunicationType } from '@apis/rights-management/rightsManagementApiModels';
import { SocialNetwork } from '@models/SocialNetwork';
import { TrackingId, TrackingIdPrefix } from '@models/TrackingId';

import { RIGHTS_STATUS } from 'app/bulk-actions/bulk-actions-constants/bulk-actions-constants';

const UIA_RIGHTS_FLOW_TRACKING_PREFIX: TrackingIdPrefix = 'uia-rights-flow-';

export const UIA_RIGHTS_FLOW_TRACKING_IDS = {
  DM_PERMISSION_FACEBOOK_REFRESH_CONNECTION_LINK: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}dm-permission-facebook-refresh-connection-link`,
  DM_PERMISSION_SETUP_GUIDE_LINK: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}dm-permission-setup-guide-link`,
  MARK_APPROVED_RIGHTS_OPTION: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}mark-approved-rights-option`,
  MARK_APPROVED_EXPIRY_DATE_PICKER: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}mark-approved-date-picker`,
  MARK_APPROVED_UPSERT_EXPIRY_DATE: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}upsert-expiry-date`,
  MARK_APPROVED_EXPIRY_DATE_LEARN_MORE: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}mark-approved-expiry-date-learn-more`,
  MARK_APPROVED_REMOVE_EXPIRY_DATE: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}mark-approved-remove-expiry-date`,
  MARK_APPROVED_PREVIOUS_BUTTON: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}mark-approved-previous-button`,
  MARK_APPROVED_SUBMIT_BUTTON: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}mark-approved-submit-button`,
  MARK_APPROVED_DONE_BUTTON: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}mark-approved-done-button`,
  OWNED_RIGHTS_DONE_BUTTON: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}owned-rights-done-button`,
  REQUEST_RIGHTS_OPTION: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}request-rights-option`,
  REQUEST_RIGHTS_IN_DIRECT_MESSAGE_BUTTON: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}request-rights-in-direct-message-button`,
  REQUEST_RIGHTS_IN_COMMENT_BUTTON: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}request-rights-in-comment-button`,
  SKIP_RIGHTS_CONFIRM_SKIP_BUTTON: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}skip-rights-confirm-skip-button`,
  SKIP_RIGHTS_OPTION: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}skip-rights-option`,
  SKIP_RIGHTS_PREVIOUS_BUTTON: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}skip-rights-previous-button`,
  SKIP_RIGHTS_DONE_BUTTON: `${UIA_RIGHTS_FLOW_TRACKING_PREFIX}skip-rights-done-button`,
} as const satisfies Record<string, TrackingId>;

export const MANAGE_RIGHTS_REQUEST_ARTICLE_URL =
  'https://docs.bazaarvoice.com/articles/#!vibe/manage-and-request-rights/q/requesting%2520rights%2520on%2520ugc/qid/29367/qp/1';

export const DM_PERMISSION_SETUP_GUIDE_URL =
  'https://docs.bazaarvoice.com/articles/#!vibe/manage-and-request-rights/a/h4_1918694050';

export const RIGHT_STATUSES_READ_ONLY_FORM = [
  RIGHTS_STATUS.APPROVED,
  RIGHTS_STATUS.INITIATED,
  RIGHTS_STATUS.PENDING,
  RIGHTS_STATUS.QUEUED,
  RIGHTS_STATUS.EXPIRED,
];

export const RIGHT_STATUSES_UNFINISHED = [
  RIGHTS_STATUS.INITIATED,
  RIGHTS_STATUS.PENDING,
  RIGHTS_STATUS.QUEUED,
];

export const RIGHT_STATUSES_REQUESTABLE = [
  RIGHTS_STATUS.EXPIRED,
  RIGHTS_STATUS.FAILED_TO_SEND,
  RIGHTS_STATUS.NONE,
  RIGHTS_STATUS.UNSENT,
];

export const RIGHTS_REQUEST_EXTERNAL_APPROVAL_COMMUNICATION_TYPES = [
  RightsRequestCommunicationType.BV_SAMPLING_CAMPAIGN,
  RightsRequestCommunicationType.BV_CREATORS_CAMPAIGN,
];

export const FB_IG_NETWORKS = [SocialNetwork.Instagram, SocialNetwork.Facebook];
